import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconVideoSvg } from './IconVideoSvg';

export type IconVideoProps = UseIconProps;

export function IconVideo(props: IconVideoProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconVideoSvg} {...iconProps} />;
}
